import $ from 'jquery';
import {renderRecaptcha} from './utilities';
/**
 * contact module
 *
 * @module contact
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-01 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-02 using ChatGPT
 */

class Contact {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setupBinds();
    this.loadMapsApi();
  }

  setupDefaults() {
    this.$captchaResponse = this.$el.find('.captchaResponse');
  }

  setupBinds() {
    renderRecaptcha(this.$el.find('.g-recaptcha'))
      .done((grecaptcha, id) => {
        this.captchaId = id;
        this.grecaptcha = grecaptcha;
      });

    this.$el.on('click', '.submitBtn', this.onSubmitClick.bind(this));
    this.$el.find('form').on('submit', this.validateForm.bind(this));
  }

  loadMapsApi() {
    window.mapLoaded = this.onApiLoaded.bind(this);
    $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyA166pMvjqJZKM2H3GeF5IAMkdPNddD-ow&callback=mapLoaded', () => {});
  }

  onApiLoaded() {
    //to add a custom label do this:
    // https://stackoverflow.com/questions/5603623/how-can-i-show-label-title-for-marker-permanently-in-google-maps-v3
    let $map = this.$el.find('.map');
    let latLon = {lat: 44.978443, lng: -93.268651};
    let map = new google.maps.Map(this.$el.find('.map')[0], {
        center: latLon,
        zoom: 17,
        mapTypeControl: false,
        fullscreenControl: false,
      });
    let styles = [
      {
        featureType: "poi",
        elementType: "business",
        stylers: [
          { visibility: "off" }
        ]
      }
    ];

    map.setOptions({styles: styles});
    var marker = new google.maps.Marker({
      map: map,
      place: {
        placeId: 'ChIJZ-tC7ZAys1IRRMacQwgqUBA',
        location: latLon,
      },
      label: {
        color: '#aa0000',
        fontWeight: 'bold',
        text: $map.data('label')
      },
      icon: {
        labelOrigin: new google.maps.Point(0, 50),
        url: '/assets/img/marker_red.png',
        size: new google.maps.Size(22, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(11, 40),
      }
    });
  }


  onSubmitClick(e) {
    $(e.currentTarget).parents('form').addClass('submit-attempted');
  }

  validateForm(e) {
    const response = this.grecaptcha.getResponse();
    e.preventDefault();
    e.stopImmediatePropagation();

    if (response !== '') {
      this.onSubmit(e);
    } else {
      this.$captchaResponse.show();
      throw new Error("Google reCaptcha is not completed - please get a valid response from reCaptcha before submitting.");
    }
  }

  onSubmit(e) {
    const $form = $(e.currentTarget);
    const $parent = $form.parent();
    $parent.addClass('submitting');
    const data = new FormData(e.currentTarget);
    e.preventDefault();
    e.stopImmediatePropagation();
    var baseURL = window.location.origin; // This will be the CNAME domain
    $.ajax({
      url: `${baseURL}/contact-form/send`,
      data: data,
      type: 'POST',
      cache: false,
      contentType: false,
      processData: false,
      statusCode: {
          302: function() {
              // Handle redirect as success
              $parent.removeClass('submitting').addClass('thanks');
          }
      },
      success: function(response, textStatus, jqXHR) {
          // Check if the response isn't a redirect
          if(jqXHR.status !== 302) {
              $parent.removeClass('submitting').addClass('thanks');
          }
      },
      error: function(jqXHR, textStatus, errorThrown) {
          // Check if the error isn't due to the redirect
          if(jqXHR.status !== 302) {
              alert('An error occurred. Please try again.');
          }
      },
      complete: function(jqXHR, textStatus) {
          // Additional logic to run regardless of success or error
          // For example, logging or cleanup
      }
  });
  
  

    return false;
  }
}

export default Contact;
